/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoHeader implements angular.IDirective {
        restrict = "E";
        transclude: { [slot: string]: string };
        scope = {
            context: "=",
            contentKey: "@",
            bgClass: "@?",
            backArrow: "&?",
            backArrowHide: "@?",
            displayBackArrow: "=?",
            isLightBg: "<?",
            titleClass: "@?",
            additionalTitleClass: "@?"
        };

        templateUrl = 'app/components/controls/layout/headerTemplate.html';

        constructor() {
            this.transclude = {
                'icon': '?icon',
                'additionalTitle': '?additionalTitle'
            };
        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            if (_.isUndefined(scope.bgClass)) { scope.bgClass = 'bg-default-gray'; }
            if (_.isUndefined(scope.displayBackArrow)) scope.displayBackArrow = false;
            if (_.isUndefined(scope.backArrowHide)) scope.backArrowHide = 'hide-gt-xs';

            scope.isLightBg = _.isUndefined(scope.isLightBg) ? false : true;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoHeader();
            };

            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoHeader", MeevoHeader.factory());
}
